<template>
  <div class="table-scroll">
    <v-table density="compact" class="elevation-1 preview-table">
      <thead>
        <tr>
          <th class="text-left corner-cell">{{ $t('accessLevelPreviewCorner') }}</th>
          <th v-for="column in levels" :key="column.code" class="text-center">
            <span class="font-weight-bold">{{ column.code }}</span>
            <v-tooltip v-if="nameOf(column)" activator="parent" location="top">{{ nameOf(column) }}</v-tooltip>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in levels" :key="`level-${row.code}`">
          <td class="row-head">
            <span class="font-weight-bold mr-2">{{ row.code }}</span>
            <span class="text-caption text-grey-darken-1">{{ nameOf(row) }}</span>
          </td>
          <td v-for="(column, columnIndex) in levels" :key="column.code" class="text-center">
            <v-icon v-if="rowIndex >= columnIndex" color="success" size="20" :aria-label="$t('accessLevelPreviewAllowed')">mdi-check</v-icon>
            <v-icon v-else color="error" size="20" :aria-label="$t('accessLevelPreviewDenied')">mdi-close</v-icon>
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
/**
 * ตาราง C ของหน้า `/AccessLevelConfig` (#914, อ่านอย่างเดียว) — ระดับผู้ใช้ (แถว) × ระดับของ intent (คอลัมน์)
 * ตามกติกาเดียวกับ `AccessLevelPolicy.IsAllowed`: ผ่านเมื่อ rank ผู้ใช้ ≥ rank intent · rank = ตำแหน่งใน `levels`
 * (หน้าแม่ส่ง**ลำดับร่าง**มา ⇒ กด ▲▼ แล้วตารางเปลี่ยนทันทีก่อนบันทึก)
 */
export default {
  name: 'AccessLevelPreviewMatrix',
  props: {
    /** ระดับตามลำดับร่าง (ต่ำ → สูง) `[{ code, nameTh, nameEn }]` */
    levels: { type: Array, default: () => [] },
  },
  methods: {
    nameOf(level) {
      return (level && (level.nameTh || level.nameEn)) || '';
    },
  },
};
</script>

<style scoped>
.table-scroll {
  overflow-x: auto;
}

.corner-cell {
  min-width: 220px;
}

.row-head {
  white-space: normal;
  min-width: 220px;
}
</style>
